module.exports = __webpack_public_path__ + "media/images/pc/reports/main_visual_06-cfa8884caa0fe49bd32d6036945c1f3c.jpg";